import { RestrictedAccountObject } from "./restricted-account-object.model";
import { AccountObjectStoreFacade } from "../account-object/account-object.store-facade";
import { AccessGroup } from "../access-group/access-group.model";
import { Observable } from "rxjs/Observable";
import { Membership } from "../membership/membership.model";
import { isInArray } from "../../../core/util/is-in-array";
import { zip } from "rxjs/observable/zip";

export abstract class RestrictedAccountObjectStoreFacade<T extends RestrictedAccountObject> extends AccountObjectStoreFacade<T> {

    getAllByAccount(accountId: string): Observable<Array<T>> {
        return zip(
            super.getAllByAccount(accountId),
            this.appFacade.objects.membership.store.getAllByAccount(accountId)
        ).map(args => {
            let objects: Array<T>;
            let memberships: Array<Membership>;
            [objects, memberships] = args;

            if (!objects.length) {
                return objects;
            }

            const accessGroups = memberships
                .map(membership => membership.accessGroups)
                .reduce((p, c) => p.concat(c));
            return objects.filter(object => isInArray(object.accessGroup, accessGroups));
        });
    }

    removeByAccessGroup(accessGroup: AccessGroup): void {
        this.removeBy(restrictedAccountObject => restrictedAccountObject.accessGroup === accessGroup.id);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/restricted-account-object/restricted-account-object.store-facade.ts